import { useCallback } from 'react';
import type { AnalyticsUsersDashboard } from '@/types/analytics/dashboard';
import { getUsersDashboard } from '@/services/analytics/dashboard.service';
import { useAnalyticsSection } from './use-analytics-section';

const EMPTY: AnalyticsUsersDashboard = {
  adminCount: 0,
  activeEditors: 0,
  lastLoginAt: null,
  internalComments: 0,
  users: [],
};

export function useAnalyticsUsers() {
  const loader = useCallback(() => getUsersDashboard(), []);
  return useAnalyticsSection(loader, EMPTY);
}
